enum Gates {
  AddToWalletGate = 'add_to_wallet_web',
  CollectStytchDeviceIntelligence = 'collect_stytch_device_intelligence',
  Contentful = 'contentful',
  DisplayCardLift = 'cardlift',
  PostieTrackingPixel = 'postie_tracking_pixel',
  ProveGate = 'proveprefill',
  ReferralsEnabled = 'acquisition_referrals',
  TagManager = 'tag_manager',
  InStoreApplicationV2 = 'in_store_application_v2',
}

export default Gates;
